<template>
  <CollapsableSection title="Public Keys">
    <ListEditor
      :addingItem="addingPublicKey"
      :buttonText="buttonText"
      component="PublicKeyFields"
      :disableAddListItem="disableAddListItem"
      :handleAddListItem="handleAddPublicKey"
      :handleChangeListItem="handleChangePublicKey"
      :handleRemoveListItem="handleRemovePublicKey"
      :headerText="headerText"
      :listItems="publicKeys"
    />
  </CollapsableSection>
</template>
<script>
/* eslint camelcase: 0 */
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { cloneDeep } from 'lodash';
import { mapActions, mapState } from 'vuex';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import CollapsableSection from 'client/components/ContentSection/CollapsableSection.vue';
import ListEditor from 'client/components/FormValidation/ListEditor.vue';

export default {
  name: 'PublicKeys',

  components: {
    CollapsableSection,
    ListEditor,
  },

  inject: ['$validator'],

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  data() {
    return {
      addingPublicKey: false,
      buttonText: 'add new public key',
      headerText: 'Create and store SSH public keys for this user.',
    };
  },

  computed: {
    ...mapState(StoreModelMap[ItemTypeConsts.systemUser], [
      'publicKeys',
    ]),

    /**
     * @todo The logic around when a public key is being added and whether to
     * disable the add list item is nearly the same as in the CustomAttributes
     * component. Can it be DRYed up and moved to a common location?
     */
    disableAddListItem() {
      // There may not be public keys until they have been fetched from the
      // server. So the lazy evaluation to check for a name and value on the
      // first attribute is required here to avoid failing in that case.
      const {
        name,
        public_key,
      } = (this.publicKeys && this.publicKeys[0]) || {};

      if (this.addingPublicKey && (!name || !public_key)) {
        return true;
      }

      return false;
    },
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  methods: {
    ...mapActions(StoreModelMap[ItemTypeConsts.systemUser], [
      'setPublicKeys',
    ]),

    /**
     * @todo Adding a tempId to the public_key as a temporary unique identifier
     * has also been copied from the CustomAttributes component. Can it be
     * DRYed out and moved to a common location?
     */
    handleAddPublicKey() {
      const publicKeys = cloneDeep(this.publicKeys);
      const publicKey = {
        tempId: String(Date.now()),
        name: '',
        public_key: '',
        create_date: '',
      };
      publicKeys.splice(0, 0, publicKey);
      this.setPublicKeys(publicKeys);
      this.addingPublicKey = true;
    },

    handleChangePublicKey(index, listItem) {
      const publicKeys = cloneDeep(this.publicKeys);
      publicKeys[index] = { ...publicKeys[index], ...listItem };
      this.setPublicKeys(publicKeys);

      if (this.addingPublicKey && index === 0 && !this.disableAddListItem) {
        this.addingPublicKey = false;
      }
    },

    handleRemovePublicKey(index) {
      const publicKeys = cloneDeep(this.publicKeys);
      publicKeys.splice(index, 1);
      this.setPublicKeys(publicKeys);

      if (this.addingPublicKey && index === 0) {
        this.addingPublicKey = false;
      }
    },
  },
};
</script>
